/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Integrations_Apis_Remove_Confirm_TitleInputs */



/**
* | output |
* | --- |
* | "Remove {name}?" |
*
* @param {Integrations_Apis_Remove_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_apis_remove_confirm_title = /** @type {((inputs: Integrations_Apis_Remove_Confirm_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Apis_Remove_Confirm_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.name} entfernen?`)
	return /** @type {LocalizedString} */ (`Remove ${i?.name}?`)
});